import "./styles.css"

import { ImDownload } from "react-icons/im"

import Banner from "../../../assets/banner.png"

import { isEmpty } from "../../../core"

import { BiX } from "react-icons/bi"

import { useState } from "react"

import { modalHandle } from "../../../core"

import { buttons } from "../../../core/db"
import { useDownloadPdf } from "../../../hooks/useDownloadPdf"
import { useCooldownAction } from "../../../hooks/useCooldownAction"
import { normalizeText } from "../../../utils/normalizeText"

const Detail = (props) => {
  const { content } = props
  let tempContent = {
    name: "?",
    description: "?",
    category: "?",
    ability: "?",
    ability_score: 0,
    subscore: 0,
    required_materials: "?",
    instruction: "?",
    participants_quantity: "0",
    space_type: "?",
    space_size: "?",
    space_quantity: "0",
  }

  const { download, isLoading } = useDownloadPdf()
  const { execute: handleClick, isPending } = useCooldownAction(
    () => download([tempContent]),
    1000,
  )

  const isDisabled = isLoading || isPending

  const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1)
  const plurality = (size) => {
    let val = size
    let text = " participante" + (parseInt(val) > 1 ? "s" : "")
    return val + text
  }

  if (!isEmpty(content)) tempContent = content

  const [toggle, setToggle] = useState(false)
  const expandir = toggle ? "detail-container-none" : "detail-container"

  const descriptionAbility = buttons.find(
    (it) =>
      normalizeText(it.title) === normalizeText(tempContent.ability) &&
      it.level === tempContent.ability_score,
  )

  return (
    <div className={`${expandir}`}>
      <div className="detail-banner">
        <div className="botao-fechar">
          <BiX
            className="navbar-icon"
            onClick={() => {
              modalHandle("close")
            }}
          />
        </div>
        <img src={Banner} alt={tempContent.name} />
      </div>
      <div className="detail-title">{tempContent.name}</div>
      <div className="detail-content-container">
        <div className="detail-content-title">Descrição</div>
        <div className="detail-content-description">
          {tempContent.description}
        </div>
        <br></br>
        {tempContent.category ? (
          <div className="detail-content-title">
            Categoria:{" "}
            <div className="etiqueta-full-modal">{tempContent.category}</div>
          </div>
        ) : null}
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">
          Habilidade {capitalize(tempContent.ability)}: Nível{" "}
          {tempContent.ability_score}
        </div>

        <div className="detail-content-description">
          {descriptionAbility && descriptionAbility.texto}
        </div>
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">Materiais Requeridos</div>
        <div className="detail-content-description">
          {tempContent.required_materials}
        </div>
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">Instrução</div>
        <div className="detail-content-description">
          {tempContent.instruction.split("\n").map((string, idx) => (
            <p className="detail-content-description" key={idx}>{string}</p>
          ))}
        </div>
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">Participantes</div>
        <div className="detail-content-description">
          {plurality(tempContent.participants_quantity)}
        </div>
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">Tipo de espaço</div>
        <div className="detail-content-description">
          {capitalize(String(tempContent.space_type).replace("Espaço ", ""))}
        </div>
      </div>
      <div className="detail-content-container">
        <div className="detail-content-title">Tamanho do espaço</div>
        <div className="detail-content-description">
          {capitalize(String(tempContent.space_size).replace("Espaço ", ""))}
        </div>
      </div>
      <div className="detail-download-button" onClick={handleClick}>
        <ImDownload />
        <p>{!isDisabled ? "Download" : "Carregando..."}</p>
      </div>
    </div>
  )
}

export default Detail
